import QRCode from 'qrcode.react';
import styles from './QR.module.scss';
import clsx from 'clsx';
import useTheme from '../../../hooks/useTheme';
import downloadSwg from '../../../assets/images/download.svg';

const QR = ({
  data,
  downloadable = false,
  className,
  bgColor,
  fgColor,
  size = 100,
  frameColor,
}: {
  data: string;
  downloadable?: boolean;
  className?: string;
  bgColor?: string;
  fgColor?: string;
  /** Сторона кода в px. По умолчанию 100 — размер на страницах реквизитов. */
  size?: number;
  /**
   * Цвет подложки вокруг кода. По умолчанию берётся из системной темы; шаблоны
   * с собственной палитрой (Lion — светлая, Pinco — тёмная) задают его явно,
   * чтобы рамка не переключалась вслед за темой ОС.
   */
  frameColor?: string;
}) => {
  const theme = useTheme();
  const download = () => {
    const canvas = document.querySelector('#QrCode') as HTMLCanvasElement;
    if (!canvas) throw new Error('<canvas> not found in the DOM');

    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream');
    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = 'QR code.png';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <div>
      <div
        className={clsx(styles.qr, className ? className : '')}
        style={{
          backgroundColor:
            frameColor ?? (theme === 'dark' ? '#1E2B3E' : '#ffffff'),
        }}
      >
        <QRCode
          id='QrCode'
          size={size}
          value={data}
          bgColor={bgColor ? bgColor : undefined}
          fgColor={fgColor ? fgColor : undefined}
        />
      </div>
      {downloadable && (
        <button
          className={styles.downloadBtn}
          onClick={download}
          data-sentry-element='qr-download'
        >
          <img src={downloadSwg} alt='download' />
        </button>
      )}
    </div>
  );
};

export default QR;
